<template>
    <div class="container">
        <div class="courseMain">
            <div class="coursebody">
                <div class="courseLine">
                    <div class="lineCour" >
                        <img src="../../assets/images/leftcour.png" @click="handleLift"/>
                    </div>
                    <div class="lineMain">
                        <div class="roundbody" v-for="(item,index) in lineYear" :key="index">
                            <p>{{item}}</p>
                            <div class="round" @click="tagRound(index)"></div>
                        </div>

                    </div>
                    <div class="lineCour" >
                        <img src="../../assets/images/rightcour.png" @click="handleRight"/>
                    </div>
                </div>
                <div class="courcontent">
                    <div class="item" v-for="item in showCour" :key="item.id">
                        <div class="itemtitle">
                            <div class="titlecour">
                                <img src="../../assets/images/cour.png"/>
                            </div>
                            <div class="title">
                                <span>{{item.description}}</span>
                            </div>
                        </div>
                        <div class="itemimg">
                            <img :src="item.url" style="width:100%;height:100%"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return{
            yearList:[],
            lineYear:[],
            sliceStartNum:0,
            sliceEndNum:3,
            courList:[],
            showCour:[]
        }
    },
    methods:{
        getCourInfo(){
            axios.get('http://www.thingo.com.cn/thingo-server/website/enterThingo/process').then(res => {
                this.courList = res.data.data
                for (let i=0; i<this.courList.length; i++) {
                    this.yearList.push(this.courList[i].year)
                }
                if (this.courList.length > 3 ) {
                    this.showCour = this.courList.slice(this.sliceStartNum,this.sliceEndNum)
                    this.lineYear = this.yearList.slice(this.sliceStartNum,this.sliceEndNum)
                } else {
                    this.showCour = this.courList
                    this.lineYear = this.yearList
                }

                console.log(this.showCour,this.lineYear)
            })
        },
        tagRound(index){
            let rounds = document.querySelectorAll('.round')
            let items = document.querySelectorAll('.item')
            for (let i=0; i<rounds.length; i++) {
                rounds[i].style.border = '2px solid #2a84cb'
                items[i].style.border = '1px solid #e0e5ee'
            }
            rounds[index].style.border = '3px solid #2a84cb'
            items[index].style.border = '1px solid #5478B9'
        },
        sliceLineYear(){
            this.lineYear = this.yearList.slice(this.sliceStartNum,this.sliceEndNum)
        },
        sliceLineCour(){
            this.showCour = this.courList.slice(this.sliceStartNum,this.sliceEndNum)
        },
        initInfoStyle(){
            let rounds = document.querySelectorAll('.round')
            for (let i=0; i<rounds.length; i++) {
                rounds[i].style.border = '2px solid #2a84cb'
            }
            rounds[0].style.border = '3px solid #2a84cb'

        },
        handleLift(){
            let year = new Date().getFullYear()
            if (this.sliceStartNum > 0) {
                this.sliceStartNum -= 1
                this.sliceEndNum -= 1
                this.sliceLineYear()
                this.sliceLineCour()
                this.$forceUpdate()
                this.initInfoStyle()
            }
        },
        handleRight(){
            if (this.sliceEndNum < this.courList.length) {
                this.sliceStartNum += 1
                this.sliceEndNum += 1
                this.sliceLineYear()
                this.sliceLineCour()
                this.initInfoStyle()
                this.$forceUpdate()
            }
        }
    },
    mounted(){
        this.getCourInfo()
        setTimeout(()=>{
            this.initInfoStyle()
        },100)

    }
}
</script>

<style scoped>
    .courseMain {
        width: 100%;
        height: auto;
    }
    .courseMain .coursebody{
        width: 1108px;
        height: auto;
    }
    .courseMain .coursebody .courseLine{
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .courseMain .coursebody .courseLine .lineCour{
        width: 100px;
        height: 22px;
        text-align: center;
        position: relative;
        bottom: 1px;
        cursor: pointer;
    }
    .courseMain .coursebody .courseLine .lineMain{
        width: 900px;
        height: 2px;
        background: #2a84cb;
        display: flex;
        justify-content: center;
    }
    .courseMain .coursebody .courseLine .lineMain .roundbody{
        width: auto;
        height: 50px;
        text-align: center;
        margin: 0 150px;
        position: relative;
        bottom: 23px;
    }
    .courseMain .coursebody .courseLine .lineMain .roundbody p{
        margin: 0;
        padding: 0;
    }
    .courseMain .coursebody .courseLine .lineMain .roundbody .round{
        width: 8px;
        height: 8px;
        background: #ffffff;
        border: 2px solid #2a84cb;
        border-radius: 50%;
        position: relative;
        left: 8px;
        cursor: pointer;
    }
    .coursebody .courcontent{
        width: 100%;
        height: auto;
        text-align: center;
    }
    .coursebody .courcontent .item{
        width: 338px;
        height: 473px;
        display: inline-block;
        margin: 10px 10px;
        border: 1px solid #e0e5ee;
        background:url('../../assets/images/courbg.png')
    }
    .coursebody .courcontent .item .itemtitle{
        width: 100%;
        height: 210px;
        display: flex;
    }
    .coursebody .courcontent .item .itemimg{
        width: 100%;
        height: 263px;
    }
    .coursebody .courcontent .item .itemtitle .titlecour{
        margin-top: 30px;
        width: 50px;
        height: auto;
    }
    .coursebody .courcontent .item .itemtitle .title{
        width: 200px;
        height: auto;
        margin: 30px 0;
        text-align: left;
    }
    .coursebody .courcontent .item .itemtitle .title span{
        font-size: 16px;
        font-family: 'PingFang SC', 'PingFang SC-Regular';
        font-weight: 400;
        color: #4f5768;
    }
</style>
